import { createContext, useContext, useEffect, useMemo, useState } from "react";
import content from "../data/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        if (typeof window === "undefined") return "es";
        return localStorage.getItem("sodeco_lang") || "es";
    });

    useEffect(() => {
        try {
            localStorage.setItem("sodeco_lang", lang);
            document.documentElement.lang = lang;
        } catch (e) {
            /* noop */
        }
    }, [lang]);

    const value = useMemo(
        () => ({
            lang,
            setLang,
            toggle: () => setLang((l) => (l === "es" ? "en" : "es")),
            t: content[lang],
        }),
        [lang]
    );

    return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
    return ctx;
};
